// src/pages/user/ExpiredLinks.js
import React from "react";
import { Paper, Typography, Box } from "@mui/material";
import AccessTimeIcon from '@mui/icons-material/AccessTime';

export default function ExpiredLinks() {
  return (
    <Paper sx={{ p: 4, borderRadius: 4 }}>
      <Box display="flex" alignItems="center" mb={2} gap={1}>
        <AccessTimeIcon color="primary" />
        <Typography variant="h5" fontWeight={700}>
          Liên kết đã hết hạn
        </Typography>
      </Box>
      <Typography color="text.secondary" mb={2}>
        Những liên kết đã hết hạn sử dụng sẽ được liệt kê tại đây.
      </Typography>
      {/* TODO: Thay bằng component hiển thị link hết hạn */}
      <Typography sx={{ mt: 2, color: "#aaa" }}>
        (Tính năng này sẽ hiển thị các liên kết hết hạn - cần bổ sung API)
      </Typography>
    </Paper>
  );
}
